import { storyblokEditable } from 'gatsby-source-storyblok';
import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';

interface IframeEmbedBlokProps extends Blok {
  iframe_url: string;
  height: number;
}

interface IframeEmbedProps {
  blok: IframeEmbedBlokProps;
}

const IframeEmbed: React.FC<IframeEmbedProps> = ({ blok }) => {
  const { iframe_url, height } = blok;
  return (
    <div {...storyblokEditable(blok)} className="w-full md:w-auto">
      <div className="container mx-auto">
        <iframe
          src={iframe_url}
          width="100%"
          height={height || '600'}
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default memo(IframeEmbed);
